import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfigService } from '@app/app.config';
import { ClientConfig } from '@app/shared/auth/interfaces/client-config.interface';

const CLIENT_CONFIG_KEY = 'APP_CLIENT_CONFIG';

@Injectable()
export class ConfigService {
  private get config(): { [key: string]: any } {
    return this.getStoredConfig();
  }

  private _config: { [key: string]: any } = {};

  constructor(
    private readonly httpClient: HttpClient,
    private readonly apiConfig: ApiConfigService,
    ) {}

  public getClientConfig(type: string): any {
    return this.config[type];
  }

  public fetchClientConfig(type: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<{ [p: string]: any }>(async resolve => {
      if (!this.config[type]) {
        await this.loadClientConfigs();
        resolve(this.config[type]);
      } else {
        resolve(this.config[type]);
      }
    });
  }

  public cleanup(): void {
    this._config = {};
    this.storeConfig();
  }

  public async loadClientConfigs(): Promise<void> {
    const configList = await this.getClientConfigs();
    this._config = configList.reduce((result, config) => {
      result[config.type] = config.config;
      return result;
    }, {});
    this.storeConfig();
  }

  public storeConfig(): void {
    localStorage.setItem(CLIENT_CONFIG_KEY, JSON.stringify(this._config));
  }

  public getStoredConfig(): { [key: string]: any } {
    return JSON.parse(localStorage.getItem(CLIENT_CONFIG_KEY)) || {};
  }

  private getClientConfigs(): Promise<ClientConfig[]> {
    return this.httpClient.get<ClientConfig[]>(this.apiConfig.clientConfigsUrl('')).toPromise();
  }
}
